import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { MeasureTextProvider } from "./Util/MeasureTextProvider";
import { WidgetDesignMeasureText } from "../Widgets/WidgetDesignMeasureText";
import { DesignParser } from "./Util/DesignParser";
import { IWidgetComponent } from "./IWidgetComponent";
import { ITableColumn } from "../../Table/ITableColumn";
import { MsoTable } from "../../Table/MsoTable";
import { app } from "../../../Frame/App";
import { DynPopup } from "../../../Components/DynPopup";
import { LayoutModel } from "../Widgets/WidgetBase";
import { IWidgetLayoutItem } from "../Server/IWidgetLayoutItem";
import { WidgetTypes } from "../Widgets/WidgetTypes";

export type WidgetDesignMeasureTextComponentProps = {
    widget: WidgetDesignMeasureText;
    measureId: number;
    markup: string;
    styles: string;
    json: string;
    clientId: string;
    permissionCheckUrl?: string;
}

export class WidgetDesignMeasureTextComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetDesignMeasureTextComponentProps;
    markup: string;
    jsonData: any;

    constructor(props: WidgetDesignMeasureTextComponentProps) {
        super(props);

        this.markup = this.props.markup;

        try {
            this.jsonData = JSON.parse(this.props.json);
        } catch (err) {
            console.log(`Could not parse json: ${this.props.json}`);
        }
    }

    public element: HTMLElement;
    getElement = () => {
        this.element = <div className={`widget Background-Blur-90-MSO ${this.props.clientId}`}>
        </div>;
    }

    public render(): HTMLElement {
        this.getElement();
        this.prepare();
        this.props.widget.setGridPosition();
        return this.element;
    }

    private parseDesign = (markup) => {
        var processedMarkup = DesignParser.processDeferredElements(markup);

        DesignParser.parseDesign(this.element, processedMarkup.markup);
        DesignParser.appendStyles(this.props.clientId, this.props.styles);
        DesignParser.executeDomFunctions(this.element, null, this.jsonData);
        DesignParser.setLinksFromJson(this.element, this.jsonData);
        //this.createMsoTables();

        for (let item of processedMarkup.deferredElements) {
            item.insert(this.element, this.jsonData);
        }

        //check for nested widgets
        this.element.querySelectorAll("[data-widget]")?.forEach(e => {
            let widgetElement = (e as HTMLDivElement);
            let src = widgetElement.getAttribute("data-src")?.replace("widget:", "");
            $.ajax({
                url: app.resolveUrl("~/Measures/WidgetCockpit?handler=Layout&" + src),
                method: "GET",
                success: (response: LayoutModel) => {
                    if (response) {
                        let layout = JSON.parse(response.widgetLayout);
                        if (layout.jsonString) {
                            let items: IWidgetLayoutItem[] = JSON.parse(layout.jsonString);
                            for (let item of items) {
                                let widget = this.props.widget.controller.createWidget(item.type);
                                widget.load(item);
                                let component = widget.createComponent(widget.column, widget.row, widget.colSpan, widget.rowSpan, response.parentId);
                                component.classList.remove("Background-Blur-90-MSO");
                                component.classList.remove("px-3");
                                widgetElement.appendChild(component);
                            }
                        }
                    } 
                },
                error: (err) => {
                    console.log("Error on appending widget: ");
                    console.log(err);
                }
            });
        });
    }

    private prepare = () => {
        var pageUrl: string = window.location.toString();

        if (this.props.permissionCheckUrl
            && pageUrl.toLowerCase().indexOf("/settings/views/cockpitlist") == -1
            && this.props.measureId) {

            // Expects an API-Method with the current measureId as route parameter that returns true or false.
            $.ajax({
                url: app.resolveUrl(this.props.permissionCheckUrl + "/" + this.props.measureId),
                method: "GET",
                success: (response) => {
                    if (response === true) {
                        this.replaceText();
                    } else {
                        // Display Message , redirect back on click on OK.
                        document.body.appendChild(
                            <DynPopup showOkButton={true} size="dialog" title={Resources.Common.information} onOk={this.redirectBack}>
                                {Resources.Common.elementCanNotOpen}
                            </DynPopup>
                        );
                    }
                },
                error: (err) => {
                    console.log("Error checking permissions on widget: ");
                    console.log(err);
                }
            });
        } else {
            this.replaceText();
        }
    }

    private redirectBack = () => {
        history.back();
    }

    private replaceText = () => {
        this.markup = MeasureTextProvider.replaceFixedPlaceholders(this.markup);
        this.markup = MeasureTextProvider.replaceLocalizedStrings(this.markup, this.jsonData);
        this.markup = MeasureTextProvider.replaceMeasureText(this.markup, this.props.measureId, this.parseDesign);
    }

    //private createMsoTables = () => {
    //    // get parent id from url
    //    let parentId = app.getParameterByName("parentId");
    //    if (app.isNullOrUndefined(parentId)) {
    //        parentId = "-1";
    //    }

    //    // get all table definitions
    //    var tableDivs = this.element.querySelectorAll(".mso-table-autogenerate");
    //    tableDivs.forEach((value: Element) => {
    //        // set parent id and create MsoTable
    //        value.setAttribute("data-parent-id", parentId);
    //        let table = new MsoTable(value as HTMLElement);
    //        table.props.getTextForNewButton = this.getTextForNewButton;
    //    });
    //}

    //private getTextForNewButton = (templateId: number): string => {
    //    if (this.jsonData && this.jsonData["newMeasureButton_" + templateId] && this.jsonData["newMeasureButton_" + templateId][app.language]) {
    //        return this.jsonData["newMeasureButton_" + templateId][app.language];
    //    }

    //    return Resources.Common.newMeasure;
    //}
}